// /help search: NFKC-normalised, case-folded substring match where every space-separated term must appear.
// Han text has no word boundaries, so terms are substrings, never \\b-delimited words.
export function normalizeHelpText(text) {
  return String(text ?? "").normalize("NFKC").toLowerCase().replace(/\s+/g, " ").trim()
}

export function helpMatches(haystack, query) {
  const terms = normalizeHelpText(query).split(" ").filter(Boolean)
  if (terms.length === 0) return true
  const text = normalizeHelpText(haystack)
  return terms.every((term) => text.includes(term))
}
